/**
 * Rectangle ↔ polygon adapters.
 *
 * The Sprint 3 prototype represents detected units as `{ nx, ny, nw, nh }`
 * rects (importer output). The v3 backend persists `Unit.polygon` as a list
 * of [x, y] pairs normalized 0..1. Converting at the boundary keeps the
 * existing model + write endpoint untouched.
 */

/** Rect (normalized 0..1) → 4-vertex polygon, clockwise from top-left. */
export function rectToPolygon(rect) {
    const { nx, ny, nw, nh } = rect;
    return [
        [nx, ny],
        [nx + nw, ny],
        [nx + nw, ny + nh],
        [nx, ny + nh],
    ];
}

/** Polygon → bbox rect (lossy — only useful for round-trip preview). */
export function polygonToRect(polygon) {
    if (!Array.isArray(polygon) || polygon.length < 3) return null;
    let minX = 1, minY = 1, maxX = 0, maxY = 0;
    for (const [x, y] of polygon) {
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
    }
    return { nx: minX, ny: minY, nw: maxX - minX, nh: maxY - minY };
}
